export const encodeId = id => btoa(String(id));
export const decodeId = base64String => Number(atob(base64String));
